export default __webpack_public_path__ + "static/media/lamp.b68f9de3.jpg";